import { CountUp } from 'use-count-up';
import styles from '../../styles/modules/about/AboutCounters.module.scss';

const AboutCounters = () => {
  return (
    <div className={styles.counters}>
      <div className={styles.counter}>
        <span>
          ~<CountUp isCounting end={33606} duration={5} thousandsSeparator=" " />
        </span>
        <div className={styles.subtext}>Реализованных объекта</div>
      </div>
      <div className={styles.counter}>
        <span>
          ~<CountUp isCounting end={12097} duration={5} thousandsSeparator=" " prefix="~" />
        </span>
        <div className={styles.subtext}>Объектов во внутренней базе</div>
      </div>
      <div className={styles.counter}>
        <span>
          <CountUp isCounting end={171} duration={5} />
        </span>
        <div className={styles.subtext}>Активных агента</div>
      </div>
      <div className={styles.counter}>
        <span>
          <CountUp isCounting end={7} duration={5} />
        </span>
        <div className={styles.subtext}>Работающих филиалов</div>
      </div>
    </div>
  );
};

export default AboutCounters;
